
import React from "react";
import style from "./pastor.module.css";
import { Col, Row } from "react-bootstrap";
import PastorChurches from "./pastorchurches";
import PastorLaunchKit from "./launchKit";
import { IoIosInformationCircleOutline } from "react-icons/io";
const Pastor = () => {
    return (
        <>
            <div className={style.mainpastordiv}>
                <div className="container">
                    <Row className={style.pastorouterdiv}>
                        <Col
                            xs={12}
                            md={12}
                            lg={6}
                            className={`${style.pastortext} order-2 order-lg-1`}
                        >

                            <div className={style.pastortextdiv}>
                                <p>
                                    OFFICIAL FUNDRAISING PARTNER OF THE HBCU HOPE PROJECT
                                </p>

                            </div>

                            <h1>
                                Mobilize Your Church to
                                Support HBCU Students
                                — In One Simple Step.
                            </h1>

                            <p className={style.pastorpara}>
                                Create your church’s campaign, invite your ministry leaders, and watch hope spread. No overhead, no administrative burden, just collective impact.
                            </p>
                            <div className={style.pastorbuttons}>
                                <button>
                                    Launch Your Church Campaign
                                </button>

                                <button>
                                    See How It Works
                                </button>
                            </div>
                        </Col>

                        <Col xs={12}
                            md={12} lg={6}  className={`${style.pastorvideo} order-1 order-lg-2`}>
                            <div className={style.videocomponent}>
                                <video
                                    width="100%"
                                    controls
                                    autoPlay
                                    muted
                                    loop
                                >
                                    <source src="/animation.mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </div>


                        </Col>
                    </Row>
                </div>


            </div>


            <div className="container">

                <div className={style.videocomponent}>
                    <video
                        width="100%"
                        controls
                        autoPlay
                        muted
                        loop
                    >
                        <source src="/pastor.mp4" />
                        Your browser does not support the video tag.
                    </video>
                    <h2>
                        A message of gratitude
                    </h2>

                    <p>
                        — and how your church can change a student’s life.
                    </p>

                </div>
            </div>
            <div className={style.main}>
                <div className="container">
                    <div className={style.innerContainer}>
                        <h1>How It Works</h1>
                        <div className={style.imgDiv}>
                            <IoIosInformationCircleOutline  className="ioinfo"/>
                            <span>NO COST TO THE CHURCH. NO OFFERING REQUIRED.</span>
                        </div>
                        <div className={style.howitworks}>
                            <div className={style.card}>
                                <img src="/card1.png" alt="step1" className={style.cardImg} />
                                <h3>1. Create Your Church’s Campaign</h3>
                                <p>
                                    Choose your recipient (TSU Bus or PVAMU Bus), launch date,
                                    and pledge amount.
                                </p>
                            </div>
                            <div className={style.card2}>
                                <img src="/card2.png" alt="step1" className={style.cardImg} />
                                <h3>2. Log In & Invite Up to Four Group Leaders</h3>
                                <p>
                                    Each leader receives a link to create their ministry’s page.
                                </p>
                            </div>
                            <div className={style.card}>
                                <img src="/card3.png" alt="step1" className={style.cardImg} />
                                <h3>Group Pages Autofill Automatically</h3>
                                <p>
                                    Recipient, start date, and church details carry over — no
                                    extra setup.
                                </p>
                            </div>
                            <div className={style.card}>
                                <img src="/card4.png" alt="step1" className={style.cardImg} />
                                <h3>4. Members Share Their Links</h3>
                                <p>
                                    Anyone can donate to the master church campaign or to a
                                    ministry group.
                                </p>
                            </div>
                            <div className={style.card}>
                                <img src="/card5.png" alt="step1" className={style.cardImg} />
                                <h3>5. FundLife Handles the Rest</h3>
                                <p>
                                    Messaging, donation processing, receipts, reporting, and
                                    updates are automated.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <PastorChurches />

            <div className={style.container}>
                <h1 className={style.heading}>Pastors are Seeing the Impact</h1>

                <div className={style.cardWrapper}>
                    {/* Card 1 */}
                    <div className={style.cardd}>
                        <div className={style.churchGroupp}>
                            <p className={style.text}>
                                “Fundlife made it easy for our church to unite and make a
                                difference for HBCU students.”
                            </p>
                            <img
                                src="/99Icon.png"
                                alt="imgPaster"
                                className={style.pasterImg}
                            />
                        </div>

                        <div className={style.profile}>
                            <div className={style.avatar}></div>
                            <div className={style.profileInfo}>
                                <h4>Dr. Marcus Sterling</h4>
                                <span>New Hope Baptist Church</span>
                            </div>
                        </div>
                    </div>

                    {/* Card 2 */}
                    <div className={style.cardd}>
                        <div className={style.churchGroupp}>
                            <p className={style.text}>
                                “Our ministry leaders loved leading their own pages. The
                                friendly competition inspired everyone!”
                            </p>
                            <img
                                src="/99Icon.png"
                                alt="imgPaster"
                                className={style.pasterImg}
                            />
                        </div>

                        <div className={style.profile}>
                            <div className={style.avatar}></div>
                            <div className={style.profileInfo}>
                                <h4>Pastor Michelle T</h4>
                                <span>Faith Community Church</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <PastorLaunchKit />
 <div className={style.container}>
         <div className={style.launchMain}>
           <div className={style.launchChurch}>
            <h1>Ready to Launch Your Church Campaign?</h1>
            <p>Create your page in minutes and invite your ministry leaders today.</p>
            <div className={style.btnDiv}> 
              <button className={style.btnChurch}>Launch Your Church Campaign</button>
              <button className={style.btnTeam}>Talk to Our Team</button>
            </div>
          </div>
         </div>
        </div>
        </>
    )
}
export default Pastor;
